export default __webpack_public_path__ + "static/media/app-screens-v2-67-2_04.388b2a89.jpg";